import { useQuery } from "react-query";
import { fetchEventsAndCategories } from "lib/api";

const useSearchEventsAndCategories = (search) => {
  return useQuery(["search", search], () => fetchEventsAndCategories(search), {
    enabled: !!search && search.length > 2,
  });
};

export { useSearchEventsAndCategories };
